import React from 'react'
import PropTypes from 'prop-types'
import ButtonComponent from "react-bootstrap/Button";
import { Spinner } from 'react-bootstrap';
import Icon from './Icon';
import TooltipF from '../../TooltipF';
export default function Button(props) {

    const Icons = () =>{
        return(
            <Icon icon={props?.icon} />
        )
    }
    const renderView = () =>{
        if(props?.icon){
            return Icons();
        }
        return(
            props?.children
        )
    }
    const onClick = (e) =>{
        e.preventDefault();
        if(props?.onClick){
            props?.onClick(e);
        }
    }
    const styles = {
    }
    if(props?.padding){
        styles['padding'] = `${props?.padding}`
    }

    if(props?.iconSize){
        styles['--width'] = `${props?.iconSize}px`
        styles['--height'] = `${props?.iconSize}px`
    }
    const renderLoader = () =>{
        if(!props?.loader){
            return null
        }
        return(
            <Spinner/>
        )
    }
    const renderBody = () =>{
        return (
            <ButtonComponent onClick={onClick} disabled={props?.disabled} type={props?.type} className={`button-component fw-${props?.fw} ${props?.loader ?"btn-loader": ""} ${props?.icon?"btn-icon":""} ${props?.className} ${props?.after ?`after-button after-${props?.after}`: ""} btn-${props?.size} btn-${props?.icon ?"icon": props?.button_type || "button"} ${props?.radius}`} variant={props?.variant}  style={{...styles,}}>
                <div className='button-content d-flex'>
                    {renderView()}
                    {renderLoader()}
                </div>
            </ButtonComponent>
        )
    }
    if(props?.title){
        return(
            <TooltipF title={props?.title} placement={props?.placement}>
                {renderBody()}
            </TooltipF>
        )
    }
    return renderBody();
}

Button.propTypes = {
    variant: 'primary-hover-success' |'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' | 'light' | 'link' | 'outline-primary' | 'outline-secondary' | 'outline-success' | 'outline-danger' | 'outline-warning' | 'outline-info' | 'outline-dark' | 'outline-light'| PropTypes.string,
    button_type:"button" | "icon",
    after:"primary" | "success",
    size:"sm" | "md" | "nm" | "lg" | "xl",
    iconSize: PropTypes.number,
    icon: PropTypes.any,
    type: PropTypes.any,
    height: PropTypes.any,
    width: PropTypes.any,
    className: PropTypes.any,
    disabled: PropTypes.any,
    padding: PropTypes.any,
    onClick: PropTypes.any,
    radius: PropTypes.number | "rounded",
    loader: PropTypes.bool,
}